import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import { Button, Form, Input } from "antd";
import "./index.css";
import "../common/forms.css";

const EditProfilePage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    const response = await ApiService.getUserProfile();
    setUser(response);
    form.setFieldsValue({
      name: response?.name,
      email: response?.email,
      phoneNumber: response?.phoneNumber,
    });
  };

  const handleDeleteProfile = async () => {
    if (!window.confirm("Are you sure you want to delete your account")) {
      return;
    }
    await ApiService.deleteUser(user.id);
    navigate("/sign-up");
  };

  const handleUpdateProfile = async (values) => {
    setLoading(true);
    await ApiService.updateUser(user.id, values);
    await fetchUserProfile();

    setLoading(false);
  };

  return (
    <div className="edit-profile-page">
      <h2>Edit Profile</h2>
      {user && (
        <div className="form-page-container">
          <Form
            form={form}
            layout="vertical"
            onFinish={(values) => handleUpdateProfile(values)}
          >
            <Form.Item
              label="Name"
              name={"name"}
              rules={[{ required: true, message: "User name is required" }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Email"
              name={"email"}
              rules={[
                { required: true, message: "Email Address is required" },
                {
                  type: "email",
                  message: "Please input a valid email address",
                },
              ]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              label="Phone Number"
              name={"phoneNumber"}
              rules={[{ required: true, message: "Phone number is required" }]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item className="action-button-default">
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading}
                style={{ marginRight: 8 }}
              >
                {loading ? "Loading..." : "Update Profile"}
              </Button>
              <Button
                danger
                onClick={handleDeleteProfile}
                disabled={loading}
              >
                {loading ? "Loading..." : "Delete Profile"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
    </div>
  );
};

export default EditProfilePage;
